import React from 'react';
import './pages.css';

const About = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="about-box">
          <h1>About Us</h1>
          <p>
            At IESG, we take pride in being a cornerstone of the community, 
            proudly Canadian and local. With a license number of <strong>7017325</strong>, 
            we have established ourselves as a trusted name in the industry for many years.
          </p>
          <p>
            Our journey began with a simple mission: to provide exceptional service and quality 
            craftsmanship in every project we undertake. Over the years, we have successfully 
            completed numerous home projects, transforming spaces and enhancing the lives of our 
            clients. Our dedication to hard work and excellence has earned us a reputation for 
            reliability and professionalism.
          </p>
          <p>
            We believe that every home is unique, and we approach each project with a fresh perspective. 
            Our team of skilled professionals is committed to understanding your vision and bringing it 
            to life. Whether it's a small renovation or a large-scale construction project, we treat 
            every job with the utmost care and attention to detail.
          </p>
          <p>
            As a local business, we are deeply invested in our community. We strive to support local 
            initiatives and contribute to the growth and development of our surroundings. Our success 
            is not just measured by the projects we complete, but by the relationships we build with 
            our clients and the positive impact we have on our community.
          </p>
          <p>
            Thank you for considering IESG for your next project. We look forward to 
            working with you and turning your dreams into reality. Together, let's create something 
            extraordinary!
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;